"use client";

import { IconArrowRotateClockwise } from "central-icons/IconArrowRotateClockwise";
import { IconCircleCheck } from "central-icons/IconCircleCheck";
import { AnimatePresence, m } from "motion/react";
import { useState } from "react";
import Comparison from "@/components/preview/comparison";
import { Button } from "@/components/ui/button";
import { SPRING } from "@/lib/motion";

function Toast({ animateOnMount }: { animateOnMount: boolean }) {
  return (
    <AnimatePresence initial={animateOnMount}>
      <m.div
        animate={{ opacity: 1, scale: 1, y: 0 }}
        className="flex select-none items-center gap-2.5 rounded-xl bg-preview-bg py-3 pr-4 pl-3 shadow-custom will-change-transform"
        initial={{ opacity: 0, scale: 0.9, y: 12 }}
        key="toast"
        transition={SPRING}
      >
        <IconCircleCheck className="size-5 shrink-0 text-gray-1200" />
        <span className="font-medium text-gray-1200 text-sm">
          Changes saved
        </span>
      </m.div>
    </AnimatePresence>
  );
}

export default function AnimationSkipPageLoadDemo() {
  const [load, setLoad] = useState(0);

  return (
    <Comparison
      bad={<Toast animateOnMount key={load} />}
      footer={
        <Button
          className="group"
          leftIcon={
            <IconArrowRotateClockwise className="size-4 text-gray-1000 transition-transform duration-300 ease-out will-change-transform group-active:rotate-90" />
          }
          onClick={() => setLoad((value) => value + 1)}
          rounded
          size="sm"
          type="button"
          variant="secondary"
        >
          Reload page
        </Button>
      }
      good={<Toast animateOnMount={false} key={load} />}
      panelClassName="h-40"
      stackBelow="sm"
    />
  );
}
